var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5",staticStyle:{"float":"left","width":"100%"}},[_c('project-detail',{attrs:{"project-dtl":_vm.projectDtl,"spend-hours-detail":_vm.spendHoursDetail}}),_c('timeline',{attrs:{"project-dtl":_vm.projectDtl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }